import axios from 'axios';

let baseURL = process.env.VUE_APP_API_URL;
const hostName = window.location.hostname;
const protocol = window.location.protocol;

// if (hostName === 'api.jiopayu.com') {
//   baseURL = protocol + '//api.jiopayu.com/api/v1';
// } else if (hostName === 'jiopayu.com') {
//   baseURL = protocol + '//jiopayu.com/api/v1';
if (hostName == 'localhost') {
  baseURL = protocol + '//localhost:3000/api/v1';
// } else if (hostName === 'best-live-404609.uc.r.appspot.com') {
//   baseURL = protocol + '//best-live-404609.uc.r.appspot.com/api/v1';
} else if (hostName == 'jiopayu.com') {
  baseURL = protocol + '//bc.jiopayu.com/api/v1';
} else if (hostName == 's.jiopayu.com') {
  baseURL = protocol + '//sbc.jiopayu.com/api/v1';
}
// } else if (hostName.match(/^\d+\.\d+\.\d+\.\d+$/)) {
//   // Handle IP addresses - use port 3000 for local development
//   baseURL = protocol + '//' + hostName + ':3000/api/v1';
// } else {
//   baseURL = protocol + '//' + hostName + '/api/v1';
// }

export default axios.create({
  baseURL,
  headers: {
    'Content-type': 'application/json'
  },
  withCredentials: true
});
